import { useEffect, useCallback } from "react";

declare global {
  interface Window {
    fbq: Fbq;
    _fbq?: Fbq;
  }
}

type Fbq = {
  (command: string, ...args: any[]): void;
  callMethod?: (...args: any[]) => void;
  push?: (...args: any[]) => void;
  loaded?: boolean;
  version?: string;
  queue?: any[];
  initialized?: boolean;
};

const useFacebookPixel = (pixelId: string): (event: string, params?: Record<string, any>) => void => {
  useEffect(() => {
    if (!window.fbq || !window.fbq.initialized) {
      (function (f: any, b: Document, e: string, v: string, n: any, t: HTMLScriptElement, s: Node | null) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s?.parentNode?.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js",
        null,
        document.createElement("script"),
        document.getElementsByTagName("script")[0]
      );
 
      window.fbq("init", pixelId);
      window.fbq.initialized = true; // mark as initialized
    }
 
    window.fbq("track", "PageView");
  }, [pixelId]);
 
  const trackEvent = useCallback((event: string, params?: Record<string, any>) => {
    if (typeof window !== "undefined" && window.fbq) {
      if (params && typeof params !== 'object') {
        console.warn("Event parameters must be an object");
      }
      window.fbq("track", event, params || {});
    }
  }, []);
 
  return trackEvent;
};

export default useFacebookPixel;
